import { __decorate } from "tslib";
import { handleError } from '@blade/common/utils/handle-error';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { OrganizationModule } from '@blade-sxp/account/store/organization';
import { mapTree } from '@blade-sxp/account/utils/orgnization-map-tree';
import TreeSelect from '@blade-sxp/account/components/tree-select.vue';
let default_1 = class default_1 extends Vue {
    openMode;
    form = {
        id: '',
        name: '',
        code: '',
        upDept: '',
        upId: '',
        desc: '',
    };
    get organizationRules() {
        return {
            name: [
                {
                    required: true,
                    message: this.$t('orgName').toString(),
                    trigger: ['blur', 'change'],
                },
            ],
            code: [],
            upDept: [
                {
                    required: true,
                    message: this.$t('orgUpper').toString(),
                    trigger: ['blur', 'change'],
                },
            ],
            desc: [
                {
                    required: true,
                    message: this.$t('orgDesc').toString(),
                    trigger: ['blur', 'change'],
                },
            ],
        };
    }
    isOpen = false;
    id = '';
    treeData = [];
    handleClose() {
        console.log('reject close');
        this.resetForm();
        this.$emit('close-dialog');
    }
    mounted() {
        this.getTreeData();
    }
    handleSubmit() {
        this.$refs['organization-form'].validate(async (valid) => {
            if (valid) {
                // alert('submit!');
                try {
                    if (this.openMode === 'ORGAEDIT') {
                        await OrganizationModule.updateOrganizationDetail({
                            description: this.form.desc,
                            id: this.form.id,
                            name: this.form.name,
                        });
                    }
                    else {
                        await OrganizationModule.createOrganization({
                            description: this.form.desc,
                            name: this.form.name,
                            pid: this.form.upId,
                        });
                    }
                    console.log('valid:', this.form);
                    this.resetForm();
                    this.$emit('submit-dialog', this.openMode);
                }
                catch (e) {
                    this.$emit('error-dialog', e);
                }
                // this.handleUpdateUser();
            }
            else {
                console.log('error submit!!', this.form);
                return false;
            }
        });
    }
    async getData() {
        console.log('open mode:', this.openMode);
        if (this.openMode === 'ORGACREATE' || !this.id) {
            return;
        }
        try {
            const res = await OrganizationModule.getOrganizationDetail(this.id);
            console.log('res:', res);
            this.form.name = res.org_name;
            this.form.upDept = res.parent_name;
            this.form.id = res.id;
            this.form.desc = res.description;
            this.form.upId = res.parent_id;
        }
        catch (e) {
            handleError(e);
        }
    }
    async getTreeData() {
        try {
            const res = await OrganizationModule.getOrganizationTree();
            const mappedOrg = mapTree([res]);
            console.log('res:', mappedOrg);
            this.treeData = mappedOrg;
        }
        catch (e) { }
    }
    onOpenChange(newVal) {
        if (newVal) {
            this.getData();
            this.getTreeData();
        }
    }
    handleUpdateName(data) {
        this.form.id = data.id;
        this.form.name = data.value;
    }
    handleUpdateDep(data) {
        this.form.upDept = data.value;
        this.form.upId = data.id;
    }
    resetForm() {
        this.$refs['organization-form'].resetFields();
        this.form = { id: '', name: '', code: '', upDept: '', desc: '' };
    }
    onLocaleChange(newVal) {
        this.getData();
        this.getTreeData();
    }
};
__decorate([
    Prop()
], default_1.prototype, "openMode", void 0);
__decorate([
    Prop()
], default_1.prototype, "isOpen", void 0);
__decorate([
    Prop()
], default_1.prototype, "id", void 0);
__decorate([
    Watch('isOpen')
], default_1.prototype, "onOpenChange", null);
__decorate([
    Watch('$i18n.locale')
], default_1.prototype, "onLocaleChange", null);
default_1 = __decorate([
    Component({
        name: 'OrganizationEdit',
        components: { 'tree-select': TreeSelect },
        i18n: {
            messages: {
                'en-us': {
                    organizationName: 'Department Name',
                    code: 'Organization Code',
                    upDept: 'Upper Dept.',
                    organizationOwner: 'Organization Owner',
                    desc: 'Description',
                    submit: 'Submit',
                    cancel: 'Cancel',
                    create: 'Create',
                    ORGAEDIT: 'Edit',
                    ORGACREATE: 'Create',
                    ORGAROLE: 'Edit',
                    orgName: 'Please input department name',
                    orgUpper: 'Please select upper department',
                    orgDesc: 'Please input description',
                },
                zh: {
                    organizationName: '部门名称',
                    code: '组织编码架构',
                    upDept: '上层部门',
                    organizationOwner: '组织owner',
                    desc: '描述',
                    submit: '提交',
                    cancel: '取消',
                    create: '新增部门',
                    ORGAEDIT: '编辑部门',
                    ORGACREATE: '新增部门',
                    ORGAROLE: '编辑角色',
                    orgName: '请输入部门名字',
                    orgUpper: '请选择上层部门名字',
                    orgDesc: '请输入描述',
                },
            },
        },
    })
], default_1);
export default default_1;
